import { Typography, useMediaQuery } from "@mui/material";
import { Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ImageAssets from "../../../../assets";
import { MuiButton } from "../../../../components/common/button/MuiButton";
import { MuiDatepicker } from "../../../../components/common/datepicker/MuiDatepicker";
import MuiStepper from "../../../../components/common/stepper/MuiStepper";
import { MuiTextField } from "../../../../components/common/textfield/MuiTextField";
import constants from "../../../../core/constants/Constants";
import routesNames from "../../../../routes/RouteNames";
import strings from "../../../../strings/Strings";
import styles from "./registration.module.css";
import moment from "moment";
import RegistrationOtpVerification from "../registration/RegistrationOtpVerification";
import { useDispatch, useSelector } from "react-redux";
import { createProfileRequest, draftUserData, loginOtpRequest, registerWithGoogleRequest, resendLoginOtpRequest, setLoginState } from "../../../../redux/login-redux/LoginRedux";
import { UAParser } from "ua-parser-js";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { setLocalStorageItem } from "../../../../utils/LocalStorage";
import { setCookies } from "../../../../utils/Cookies";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import PhoneNumber from "../../../../components/common/phone-number/PhoneNumber";

export class CreateUserStepperEnumUtils {
    public static getCreateUserStepperEnums(): {
        id: number;
        stepLabel: string;
    }[] {
        const options: { stepLabel: string; id: number }[] = [
            {
                id: 0,
                stepLabel: "",
            },
            {
                id: 1,
                stepLabel: "",
            },
            {
                id: 2,
                stepLabel: "",
            },
        ];
        return options;
    }
}

const EmailVerification = ({ activeStep, setActiveStep }) => {

    const dispatch = useDispatch();

    const navigate = useNavigate();
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [emailErr, setEmailErr] = useState('');
    const [isShowSendCodeBtn, setisShowSendCodeBtn] = useState('');
    const [OTP, setOTP] = useState('');
    const [otpTimer, setOtpTimer] = useState(constants.otpTimer);
    const steps = CreateUserStepperEnumUtils.getCreateUserStepperEnums();
    const [showResendBtn, setShowResendBtn] = useState(false);
    const [disbaled, setDisbaled] = useState(false);
    const [user, setUser] = useState<any>(null);
    const [profile, setProfile] = useState<any>([]);
    const [showOTP, setShowOTP] = useState(false);

    const isMobile = useMediaQuery("(max-width: 839px)");

    const loginState = useSelector((state: any) => state.Login);
    const storeDraftUserData = loginState?.draftUserData;

    const [deviceInfo, setDeviceInfo] = useState({
        device: "",
        os: "",
        browser: "",
    });

    const [ipAddress, setIpAddress] = useState("");
    const [userLocation, setLocation] = useState({
        latitude: 28.6425088,
        longitude: 77.2126422,
    });

    useEffect(() => {
        if (loginState?.isOAuthSuccessfull) {
            if (loginState?.oAuthDetails?.accessToken) {
                setLocalStorageItem("token", loginState?.oAuthDetails?.accessToken);
                setCookies("userDetails", JSON.stringify(loginState?.oAuthDetails));
            } else {
                setActiveStep(1)
                setShowOTP(false);
                dispatch(draftUserData({
                    ...storeDraftUserData,
                    "fullName": profile?.name,
                    "email": profile?.email,
                }))
            }
            setProfile(null);
            setUser(null);
            dispatch(setLoginState({ key: "isOAuthSuccessfull", value: false }));
        }
    }, [loginState?.oAuthDetails]);

    useEffect(() => {
        if (loginState?.isProfileCreated) {
            setActiveStep(1)
            setShowOTP(false);
            dispatch(setLoginState({ key: "isProfileCreated", value: false }));
        }
    }, [loginState?.isProfileCreated])

    useEffect(() => {
        const fetchIpAddress = async () => {
            try {
                const response = await axios.get("https://ipinfo.io/json");
                setIpAddress(response.data.ip);
            } catch (error) {
                console.error("Error fetching the IP address:", error);
            }
        };

        fetchIpAddress();
    }, []);

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                },
                (err) => {
                    console.log(err.message);
                }
            );
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, []);

    useEffect(() => {
        const parser = new UAParser();
        const result = parser.getResult();
        setDeviceInfo({
            device: result.device.model || "Unknown Device",
            os: result.os.name || "Unknown OS",
            browser: result.browser.name || "Unknown Browser",
        });
    }, []);

    const handleStepClick = (index: number) => {
        if (activeStep === 0) {
            setActiveStep(0);
        }
    };

    const resendOtp = () => {
        setOTP("");
        setOtpTimer(constants.otpTimer);
        const reqBody = {
            forPhone: true,
            data: {
                "phoneNumber": storeDraftUserData?.phoneNumber,
                "countryCode": storeDraftUserData?.countryCode,
                "isSignUpRequest": true
            }
        };

        dispatch(resendLoginOtpRequest(reqBody));
    };

    const handleEmail = (value: any) => {
        const regexExpToCheckMail = /^[a-zA-Z0-9_]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,3})$/;
        if (regexExpToCheckMail.test(value?.trim())) {
            setisShowSendCodeBtn(value);
            setEmailErr("");
            setDisbaled(false);
        } else {
            setEmailErr(strings.enterValidEmail);
            setDisbaled(true);
        }
        dispatch(draftUserData({
            ...storeDraftUserData,
            "email": value,
        }))
    }

    const handleSendCode = () => {
        const reqBody = {
            forPhone: true,
            data: {
                "phoneNumber": storeDraftUserData?.phoneNumber,
                "countryCode": storeDraftUserData?.countryCode,
                "isSignUpRequest": true
            }
        };
        dispatch(loginOtpRequest(reqBody));
        setShowResendBtn(true);
    }

    useEffect(() => {
        if (loginState?.isLoginOtpSent) {
            setOTP("");
            setShowOTP(true);
            dispatch(setLoginState({ key: "isLoginOtpSent", value: false }));
        }
    }, [loginState?.isLoginOtpSent])

    const handleVerifyBtn = () => {
        handleSendCode();
    }

    const handleContinueBtn = () => {
        const reqBody = {
            "phoneNumber": storeDraftUserData?.phoneNumber,
            "countryCode": storeDraftUserData?.countryCode,
            "fullName": storeDraftUserData?.fullName,
            "roleId": "add2820c-44b4-4621-bf99-92ec4ceec6d9",
            "channelType": 2,
            "otp": OTP,
            deviceId: `${deviceInfo?.os} - ${deviceInfo?.browser}`,
            deviceName: `${deviceInfo?.os} - ${deviceInfo?.browser}`,
        };
        dispatch(createProfileRequest(reqBody));
        dispatch(draftUserData({
            ...storeDraftUserData,
            "otp": OTP,
        }))
    }

    const handleContinueDisbaleState = () => {
        let disable = true;
        if (storeDraftUserData?.fullName && storeDraftUserData?.phoneNumber && storeDraftUserData?.countryCode && OTP && disbaled === false) {
            disable = false;
        }
        else {
            disable = true;
        }
        return disable;
    }

    const handleDisbaleState = () => {
        const { fullName, phoneNumber, countryCode } = storeDraftUserData || {};

        // Disable if any of the required fields are missing
        if (!fullName || !phoneNumber || !countryCode) {
            return true;
        }

        // For India (+91), ensure phone number is exactly 10 digits
        if (countryCode === '+91' && phoneNumber.length !== 10) {
            return true;
        }

        // If all validations pass
        return false;
    };

    const handleOTPChange = (value) => {
        setOTP(value);
        setDisbaled(false);
    }

    useEffect(() => {
        const reqBody = {
            fullName: profile?.name,
            email: profile?.email,
            roleId: "add2820c-44b4-4621-bf99-92ec4ceec6d9",
            phoneNumber: "",
            countryCode: "",
            dob: "",
            ipAddress: ipAddress,
            latitude: userLocation?.latitude,
            longitude: userLocation?.longitude,
            channelType: 2,
            deviceId: `${deviceInfo?.os} - ${deviceInfo?.browser}`,
            deviceName: `${deviceInfo?.os} - ${deviceInfo?.browser}`,
        };
        if (profile?.name) {
            dispatch(registerWithGoogleRequest(reqBody));
        }
    }, [profile]);

    useEffect(() => {
        if (user) {
            axios
                .get(
                    `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
                    {
                        headers: {
                            Authorization: `Bearer ${user.access_token}`,
                            Accept: "application/json",
                        },
                    }
                )
                .then((res: any) => {
                    setProfile(res.data);
                })
                .catch((err: any) => { });
        }
    }, [user]);

    const login = useGoogleLogin({
        onSuccess: (codeResponse: any) => setUser(codeResponse),
        onError: () => { },
    });

    const registerWithGoogle = () => {
        login();
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const onlyNumbers = value.replace(/[^0-9]/g, "");
        dispatch(draftUserData({
            ...storeDraftUserData,
            "phoneNumber": onlyNumbers,
        }))
    }

    const handleCountryCodeSelection = (code: any) => {
        dispatch(draftUserData({
            ...storeDraftUserData,
            "countryCode": code,
        }))
    }

    const validateForm = () => {

    }

    return (
        <>
            <Stack flexDirection={'column'}>
                <Stack flexDirection={'column'}
                    className={styles["container"]}
                >
                    <Stack className={styles["stepper-container"]} flexDirection={"row"} gap={isMobile ? 5 : 11} width={'100%'} alignItems={'center'}>
                        <ArrowBackIosRoundedIcon
                            onClick={() => navigate(-1)}
                            className={styles["back-button"]}
                        />
                        <div style={{ width: '60%' }}>
                            <MuiStepper
                                activeStep={activeStep}
                                steps={steps}
                                handleStepClick={handleStepClick}
                            />
                        </div>
                    </Stack>

                    <div>
                        <Typography className={styles["heading"]}> {showOTP ? 'Enter 4 digit OTP' : strings.letsGetStarted}</Typography>
                    </div>


                    <Stack flexDirection={'column'} gap={5} className={styles["form-fields"]}>
                        <MuiTextField
                            fullWidth
                            type="text"
                            name="fullName"
                            value={storeDraftUserData?.fullName}
                            inputProps={{ "data-testid": "fullName" }}
                            label={strings.enterFullName}
                            errormessage=""
                            onChange={(e: any) => {
                                setOTP(storeDraftUserData?.fullName ? "" : OTP);
                                setisShowSendCodeBtn(storeDraftUserData?.fullName ? "true" : isShowSendCodeBtn)
                                dispatch(draftUserData({
                                    ...storeDraftUserData,
                                    "fullName": e.target.value,
                                }))
                            }}
                            component={"registrationV1"}
                        />

                        <PhoneNumber
                            autoFocus={false}
                            handleInputChange={handleInputChange}
                            handleCountryCodeSelection={handleCountryCodeSelection}
                            value={storeDraftUserData?.phoneNumber}
                            countryCode={storeDraftUserData?.countryCode}
                            errorMessage={""}
                            validateForm={validateForm}
                            component={"registrationV1"}
                            disabled={showOTP}
                        />

                        {/* <MuiTextField
                            fullWidth
                            type="text"
                            name="email"
                            label={strings.enterEmailId}
                            errormessage={emailErr || ""}
                            inputProps={{ "data-testid": "email" }}
                            value={storeDraftUserData?.email}
                            onChange={(e: any) => handleEmail(e.target.value)}
                            component={"registrationV1"}
                        /> */}

                        {showOTP &&
                            <Stack alignItems={"center"} className={styles["otp-container"]} >
                                <RegistrationOtpVerification
                                    // onEditEmailClick={onEditEmailClick}
                                    otp={OTP}
                                    setOtp={handleOTPChange}
                                    resendOtp={resendOtp}
                                    setOtpTimer={setOtpTimer}
                                    otpTimer={otpTimer}
                                    values={''}
                                    isShowSendCodeBtn={isShowSendCodeBtn ? true : false}
                                    handleSendCode={handleSendCode}
                                    showResendBtn={showResendBtn}
                                />
                            </Stack>
                        }
                    </Stack>




                    <Stack direction={"column"} alignItems={"center"} marginTop={isMobile ? '16rem' : ''}>
                        <div className={styles["btn-container"]}>
                            {showOTP ?
                                <MuiButton
                                    className={styles["verify"]}
                                    onClick={() => handleContinueBtn()}
                                    disabled={handleContinueDisbaleState()}
                                >
                                    {strings.continue}
                                </MuiButton>
                                :
                                <MuiButton
                                    className={styles["verify"]}
                                    onClick={() => handleVerifyBtn()}
                                    disabled={handleDisbaleState()}
                                >
                                    Verify
                                </MuiButton>
                            }
                        </div>



                        {/* <Stack
                            className={styles["google-fb-login"]}
                            spacing={4}
                        >
                            <div
                                onClick={(event: any) => {
                                    event.stopPropagation();
                                    registerWithGoogle();
                                }}
                                style={{
                                    display: "flex",
                                    gap: ".7rem",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "2px solid var(--tertiary-grey-color)",
                                    padding: "1rem 2rem",
                                    paddingBottom: "0.9rem",
                                    borderRadius: "50px",
                                    marginTop: "2rem",
                                    width: '100%',
                                }}
                            >
                                <img
                                    alt="google"
                                    src={ImageAssets.ic_google_color}
                                    style={{
                                        width: "3rem",
                                    }}
                                // className={styles["register-and-login"]}
                                />
                                <p style={{ color: "white", fontSize: "1.4rem" }}>
                                    Sign up with Google
                                </p>
                            </div>
                        </Stack> */}
                    </Stack>

                    <Typography className={styles["agreement"]}>
                        {strings.agreementText}{" "}
                        <p
                            className={styles["terms-link"]}
                            onClick={() => {
                                navigate(routesNames.termsAndConditionPolicy)
                            }}
                        >
                            {strings.terms}
                        </p>
                        {strings.comma}{" "}
                        <p
                            className={styles["terms-link"]}
                            onClick={() => {
                                navigate(routesNames.privacyPolicy)
                            }}
                        >
                            {strings.privayPolicy}
                        </p>{" "}
                        {strings.and}{" "}
                        <p
                            className={styles["terms-link2"]}
                            onClick={() => {
                                navigate(routesNames.cookiePolicy)
                            }
                            }
                        >
                            {strings.cookiesPolicy}
                        </p>
                    </Typography>

                    <Typography className={styles["joined-already-registration"]}>
                        {strings.haveAccount}
                        <Link
                            to={routesNames.login}
                            className={styles["login-link"]}
                        >
                            {strings.signIN}
                        </Link>
                    </Typography>
                </Stack>
            </Stack>

        </>
    );
}
export default EmailVerification;